import { IGcfOutageStamp } from 'src/interfaces';

import {
  GcfCommonComponentConfigInterface,
  GcfCommonComponentConfigSchema,
} from '../FormSelector.interface';

export enum ListingWithOptionalVisualsColumnStyle {
  continuous = 'continuous',
  category = 'category',
}

type Omit<T, K extends keyof GcfCommonComponentConfigInterface> = Pick<
  T,
  Exclude<keyof T, K>
>;

enum OptionalVisualVerticalAlignEnum {
  top = 'top',
  bottom = 'bottom',
  center = 'center',
}

enum OptionalVisualHorizontalAlignEnum {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum OptionalVisualImageSrcEnum {
  lineup = 'lineup',
  custom = 'custom',
  selected = 'selected',
}

export interface OptionalVisualItemsInterface {
  visible?: boolean;
  style?: {
    width?: string;
    height?: string;
    top?: string;
    left?: string;
    zIndex?: number;
  };
  outageStamp?: IGcfOutageStamp;
  assetName?: string;
  displaySoldout?: boolean;
}

export type KeyOfOptionalVisualItemsInterface =
  | 'width'
  | 'height'
  | 'assetName'
  | 'outageStamp.width'
  | 'outageStamp.height'
  | 'outageStamp.left'
  | 'outageStamp.top'
  | 'top'
  | 'left'
  | 'zIndex';

export interface OptionalVisualInterface {
  visible?: boolean;
  verticalAlign?: OptionalVisualVerticalAlignEnum;
  horizontalAlign?: OptionalVisualHorizontalAlignEnum;
  visualsLength?: number;
  visualsSource?: OptionalVisualImageSrcEnum;
  items: OptionalVisualItemsInterface[];
  height?: number;
  width?: number;
  offsetLeft?: string;
  offsetTop?: string;
}

export interface GcfListingWithOptionalVisualsConfigInterface
  extends Omit<GcfCommonComponentConfigInterface, 'cycling'> {
  lineupOrientation?: 'VERTICAL' | 'HORIZONTAL';
  columnStyle?: ListingWithOptionalVisualsColumnStyle;
  height?: number;
  width?: number;
  visuals?: OptionalVisualInterface;
  lineupColumns?: number;
  marginBottom?: number;
}

const {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  properties: { cycling, ...GcfCommonProperties },
} = GcfCommonComponentConfigSchema;

export const GcfListingWithOptionalVisualsConfigSchema = {
  title: 'Listing with Optional Visuals JSON Config',
  description:
    'JSON Configuration Options for GCF Listing with Optional Visuals',
  type: 'object',
  properties: {
    ...GcfCommonProperties,
  },
  required: [...GcfCommonComponentConfigSchema.required],
};

export const SelectVerticalOptions = [
  {
    label: 'Center',
    value: OptionalVisualVerticalAlignEnum.center,
  },
  {
    label: 'Top',
    value: OptionalVisualVerticalAlignEnum.top,
  },
  {
    label: 'Bottom',
    value: OptionalVisualVerticalAlignEnum.bottom,
  },
];

export const SelectHorizontalOptions = [
  {
    label: 'Center',
    value: OptionalVisualHorizontalAlignEnum.center,
  },
  {
    label: 'Left',
    value: OptionalVisualHorizontalAlignEnum.left,
  },
  {
    label: 'Right',
    value: OptionalVisualHorizontalAlignEnum.right,
  },
];
